export const GRAFANA_PREFIX = 'packages.identification_core';
